// extracted by mini-css-extract-plugin
export default {"modalContainer":"or","fadeRight":"pr","fadeUp":"qr","topShelf":"rr","newFlavorBadge":"sr","transparentText":"tr","cancelButton":"ur","invisibleLink":"vr","closeIcon":"wr","linkContainer":"xr","hed":"yr","image":"zr"};
    if(module.hot) {
      // 1713912563091
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  